import { createFeatureSelector } from '@ngrx/store';
import {Globals} from "../../Globals";


export const selectAppContextState = createFeatureSelector<Globals>('appcontext');
